import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home'

import { store } from '@/store/store.js';

import fundacion from '@/components/views/la-fundacion';
import mision from '@/components/views/mision';
import fundadores from '@/components/views/fundadores';
import transparencia from '@/components/views/transparencia';
import aguaparatodos from '@/components/views/agua-para-todos';
import civsem from '@/components/views/civsem';
import emprendimiento from '@/components/views/emprendimiento';
import mide from '@/components/views/mide';
import planesactuacion from '@/components/views/planes-de-actuacion';
import patio from '@/components/views/patio';
import colabora from '@/components/views/colabora';
import proyectosencurso from '@/components/views/proyectos-en-curso';
import proyectosfinalizados from '@/components/views/proyectos-finalizados';
import fichaproject from '@/components/views/ficha-project';
import noticias from '@/components/views/noticias';
import noticia from '@/components/views/ficha-noticia';
import gracias from '@/components/views/gracias-pago';

import crearsuscripcion from '@/components/views/crear-subscripcion';
import modificarsuscripcion from '@/components/views/modificar-suscripcion';


import login from '@/components/views/login';
import registro from '@/components/views/registro';
import areainterna from '@/components/views/area-interna';

import Contacto from '@/components/views/contacto'



import politicaCookies from '@/components/views/politica-de-cookies'
import politicaPrivacidad from '@/components/views/politica-de-privacidad'
import avisolegal from '@/components/views/aviso-legal'

Vue.use(Router)


import messages from '@/translations';

let en = messages.en.enlaces;
let es = messages.es.enlaces;

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: es.fundacion,
			name: 'fundacion',
			component: fundacion
		},
		{
			path: es.mision,
			name: 'mision',
			component: mision
		},
		{
			path: es.fundadores,
			name: 'fundadores',
			component: fundadores
		},
		{
			path: es.transparencia,
			name: 'transparencia',
			component: transparencia
		},
		{
			path: es.planesactuacion,
			name: 'planesactuacion',
			component: planesactuacion
		},
		{
			path: es.aguaparatodos,
			name: 'aguaparatodos',
			component: aguaparatodos
		},
		{
			path: es.proyectosencurso,
			name: 'proyectosencurso',
			component: proyectosencurso
		},
		{
			path: es.proyectosfinalizados,
			name: 'proyectosfinalizados',
			component: proyectosfinalizados
		},
		{
			path: es.noticias,
			name: 'noticias',
			component: noticias
		},
		{
			path: `${es.noticia}/:id?`,
			name: 'ficha-noticia',
			component: noticia
		},
		{
			path: `${es.proyecto}/:id?`,
			name: 'ficha-proyectos',
			component: fichaproject
		},
		{
			path: es.civsem,
			name: 'civsem',
			component: civsem
		},
		{
			path: es.emprendimiento,
			name: 'emprendimiento',
			component: emprendimiento
		},
		{
			path: es.mide,
			name: 'mide',
			component: mide
		},
		{
			path: es.patio,
			name: 'patio',
			component: patio
		},
		{
			path: es.contacto,
			name: 'contacto',
			component: Contacto
		},
		{
			path: es.colabora,
			name: 'colabora',
			component: colabora
		},
		{
			path: es.login,
			name: 'login',
			component: login
		},
		{
			path: es.registro,
			name: 'registro',
			component: registro
		},
		{
			path: es.areainterna,
			name: 'areainterna',
			component: areainterna,
			meta :{
				requiresAuth : true
			}
		},
		{
			path: es.crearsuscripcion,
			name: 'crearsuscripcion',
			component: crearsuscripcion,
			meta :{
				requiresAuth : true
			}
		},
		{
			path: es.modificarsuscripcion,
			name: 'modificarsuscripcion',
			component: modificarsuscripcion,
			meta :{
				requiresAuth : true
			}
		},
		{
			path: `${es.gracias}/:id?`,
			name: 'gracias',
			component: gracias
		},
		{
			path: es.politica_privacidad,
			alias: en.politica_privacidad,
			name: 'politica-de-privacidad',
			component: politicaPrivacidad
		},
		{
			path: es.politica_cookies,
			alias: en.politica_cookies,
			name: 'politica-de-cookies',
			component: politicaCookies
		},
		{
			path: es.aviso_legal,
			alias: en.aviso_legal,
			name: 'aviso-legal',
			component: avisolegal
		},
		{ path: '*', redirect: '/' },
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
});

import VueGtm from "vue-gtm";


Vue.use(VueGtm, {
	id: "GTM-N7Q6NBK", 
	enabled: true,
  });

router.beforeEach((to, from, next) => {


	//COMPRUEBO INICIO DE SESIÓN Y SI ESTÁ LOGADO
	if (to.matched.some(route => route.meta.requiresAuth) && !store.getters.getLogged) {
		next({ name: 'login' })
		return
	}

	next()
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js